import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import '@/assets/css/nprogress.css'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { i18n, vantLocales } from '@/i18n/startAccount/index.js'
import { getQueryString } from '@/utils'
import { getLangType } from '@/utils/tools.js'
import store from '@/store/demo'
import { setTheme, removeTheme } from '@/utils/theme'
import { getRunEnv } from '@/utils/env'
import { isTHSI18NApp } from '@/utils'
import { thsI18NJsBridge } from '@fs/jsbridge'
import { FISL_ACCOUNT_OPEN_TITLE } from '../openAccount/index.js'
Vue.use(VueRouter)
NProgress.configure({ showSpinner: false })

const router = new VueRouter({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: 'index',
        },
        {
            path: '/index',
            name: 'index',
            meta: {
                title: '复星国际证券开户',
            },
            component: () => import(/* webpackChunkName: "startAccountmain" */ '@/views/startAccount/index.vue'),
        },
        {
            path: '/mrStatus',
            name: 'MRStatus',
            component: () => import(/* webpackChunkName: "startAccountmain" */ '@/views/mr/mrStatus.vue'),
        },
    ],
})

router.beforeEach((to, from, next) => {
    !JSBridge && NProgress.start()
    // 存在 title 则设置 title
    const channel = to.query.channel
    const aeCode = to.query.aeCode
    // 盲盒链接配置转发  2022/10/19  hotfix
    if (channel === '0400031' && aeCode === 'B1') {
        const path = `${location.origin}/pages/newPersonActivity.html#/blindbox?aeCode=${aeCode}&channel=${channel}`
        window.location.href = path
        return false
    }

    to.meta.title ? (document.title = to.meta.title || '') : ''
    if (isTHSI18NApp()) {
        document.title = FISL_ACCOUNT_OPEN_TITLE
        thsI18NJsBridge?.changeWebViewTitle?.(FISL_ACCOUNT_OPEN_TITLE)
    }
    const lang = JSBridge ? getLangType() : getQueryString('langType') || getQueryString('langType', true) || ''
    // 国际化
    if (lang) {
        let langValue = 'zhCn'
        if (lang === 'zhTc' || lang === 'zhTC') {
            langValue = 'zhTc'
        }
        store.dispatch('app/setLang', langValue)
        i18n.locale = langValue
        vantLocales(i18n.locale)
    }
    if (to.query.fhsid) {
        store.commit('user/updateSession', { session: to.query.fhsid })
    }
    if (to.path == '/index' && getRunEnv() === 1) {
        setTheme()
    } else if (getRunEnv() === 1) {
        removeTheme()
    }
    window.scrollTo(0, 0)
    console.log(next)
    next()
})

router.afterEach(() => {
    store.commit('user/updateShowLoading', false)
    !JSBridge && NProgress.done()
})

// function getTitle() {
//     if (isTHSI18NApp()) {
//         return 'FISL account open'
//     }
//     return '复星国际证券开户'
// }

export default router
